(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrinterRemoveGoConfig(
    $http, toastr, $filter, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        printer: '=printer',
        goProfile: '=goProfile',
        meta: '=meta',
        callback: '&callback',
        updateParent: '&updateParent'
      },
      templateUrl: 'app/components/printerProperties/printerGoProfile/printerRemoveGoConfig/printerRemoveGoConfig.template.html',
      link: function(scope) {

        // scope.printer = scope.context;
        // scope.goProfile = scope.context.goProfile;
        scope.confirm = {
          delete: false
        };

        scope.delete = function () {
          var url = scope.printer.info._links['px:printerCredential'].href;
          $http.delete(url).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
            scope.updateParent();
            $rootScope.$broadcast('REMOVE_GO_FROM_PRINTER', {printer: scope.printer, goProfile: scope.goProfile});
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }


      }
    };
  }

  pxPrinterRemoveGoConfig.$inject = ['$http', 'toastr', '$filter', '$rootScope'];

  angular
    .module('printix-admin')
    .directive('pxPrinterRemoveGoConfig', pxPrinterRemoveGoConfig);

})();
